export function needsTableCleanup(html) {
  if (/intercom-interblocks/.test(html)) {
    return /data-pm-slice/.test(html);
  }
  return /<table/.test(html);
}

// Sometimes we get HTML which has paragraphs and other content nested in tables, eg:
//
// <table>
//   <tbody>
//     <tr>
//       <td>
//         <p style="margin: 0; text-align: center; mso-line-height-alt: 39px">
//           <strong>TEXT</strong>
//         </p>
//         <p>
//           Some more text
//         </p>
//       </td>
//     </tr>
//   </tbody>
// </table>
//
// This can happen if a customer pastes content from other emails
// or pages that have tables in their underlying structure.
// That results in us incorrectly parsing these tables as sections
// or multi-column layouts in the Email and Email template composers.
//
// The result should extract everything that's nested in <td> elements
// and return it as a child of a top-level div.
//
// <div>
//   <p style="margin: 0; text-align: center; mso-line-height-alt: 39px">
//     <strong>TEXT</strong>
//   </p>
//   <p>
//     Some more text
//   </p>
// </div>
//
export function stripTables(root) {
  let updatedRoot = document.createElement('div');
  updatedRoot.appendChild(traverseNodes(root));
  return updatedRoot;
}

// Allows us to recursively descend down through the node tree looking for tables,
// and keep content that is outside a table (as previously this was getting lost.
// The switch statement can be expanded to deal with more "end-of-branch" elements
// such as `img` and `#text` as we need to.
function traverseNodes(node) {
  switch (node.nodeName.toLowerCase()) {
    case 'table':
      {
        return extractContentFromNestedTables(node);
      }
    case '#text':
      {
        let element = document.createElement('span');
        element.append(node.textContent || '');
        return element;
      }
    case 'img':
      {
        return node;
      }
    case 'a':
      {
        return node;
      }
    default:
      {
        let currentNode = document.createElement(node.nodeName);
        currentNode.className = node.className;
        let childNodes = Array.from(node.childNodes);
        childNodes.forEach(child => currentNode.appendChild(traverseNodes(child)));
        return currentNode;
      }
  }
}
function extractContentFromNestedTables(node) {
  let ths = Array.from(node.getElementsByTagName('th'));
  let tds = Array.from(node.getElementsByTagName('td'));
  let tableCells = [...ths, ...tds];
  let tableCellContents = [];
  if (tableCells.length === 0) {
    return node;
  }
  tableCells.forEach(cell => {
    let cellContentNodes = Array.from(cell.childNodes);
    if (cellContentNodes) {
      cellContentNodes.forEach(node => {
        if (node.nodeName === '#text' && node.textContent) {
          let element = document.createElement('p');
          element.append(node.textContent);
          tableCellContents.push(element);
        } else if (node.nodeName.toLowerCase() !== 'table') {
          tableCellContents.push(node);
        }
      });
    }
  });
  let updatedNode = document.createElement('div');
  tableCellContents.forEach(cellContent => updatedNode.appendChild(cellContent));
  return updatedNode;
}